import React, { useState } from "react";

import { type NostoContextProps } from "~/providers/NostoProvider";

import { MultiList } from "@bared/ui";

type FacetMultiListProps = {
  data: { value: string; count: number; selected: boolean }[];
  handleChange: (value: string) => void;
  field: string;
  selectedFilters: NostoContextProps["selectedFilters"];
};

export const FacetMultiList = ({
  data,
  handleChange,
  field,
  selectedFilters,
}: FacetMultiListProps) => {
  const [showMore, setShowMore] = useState(false);

  // Safety check: return null if data is not available
  if (!data || data.length === 0) {
    return null;
  }

  // Get the selected values for this field from selectedFilters
  const selectedValues =
    selectedFilters.find((filter) => filter.field === field)?.value ?? [];

  const mappedOptions = data.map(({ value, count }) => ({
    key: value,
    count,
    checked: selectedValues.includes(value),
  }));

  const handleShowMore = () => {
    setShowMore((prev) => !prev);
  };

  return (
    <MultiList
      options={mappedOptions}
      maxOptionsToShow={10}
      handleChange={handleChange}
      handleShowMore={handleShowMore}
      showMore={showMore}
      showProductCount={true}
    />
  );
};
